import { jArticleListSchema } from './article';
import { z } from 'zod';

export const assetReservationConfigurationSchema = z.object({
    description: z.string(),
    right: z.object({
        manage: z.boolean(),
    }),
    daysOff: z.array(z.string()).optional(),
    weekEnd: z.union([z.literal('0'), z.literal('1')]),
    bookingOpeningTime: z.string(),
    bookingClosingTime: z.string(),
    lastBookingSchedule: z.string(),
});
export type AssetReservationConfiguration = z.infer<typeof assetReservationConfigurationSchema>;

export const bookableAssetListSchema = jArticleListSchema.extend({
    _isColorDark: z.boolean().nullable(),
    assetPlannerBackgroundColor: z.string().nullable(),
});
export type BookableAssetList = z.infer<typeof bookableAssetListSchema>;

export const bookableAssetViewSchema = bookableAssetListSchema.extend({
    assetBanner: z.record(
        z.object({
            id: z.string(),
            name: z.string(),
            size: z.string(),
        }),
    ),
});
export type BookableAssetView = z.infer<typeof bookableAssetViewSchema>;

export const reservationListSchema = jArticleListSchema.extend({
    dateStart: z.string(),
    dateEnd: z.string(),
    reservationCancelled: z.boolean(),
    _asset: bookableAssetListSchema,
});
export type ReservationList = z.infer<typeof reservationListSchema>;
